var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmoking = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.53.652a1 1 0 0 0-1.378.318c-.382.612-.598 1.228-.617 1.85-.018.63.17 1.181.453 1.65.508.842 1.394 1.505 2.085 2.022l.077.058c.799.6 1.366 1.043 1.65 1.514a1 1 0 0 1 .165.558c-.005.185-.07.46-.313.848a1 1 0 0 0 1.696 1.06c.382-.611.598-1.228.616-1.85a3 3 0 0 0-.452-1.65c-.509-.841-1.394-1.504-2.085-2.022l-.077-.058c-.799-.599-1.366-1.043-1.65-1.514a1 1 0 0 1-.165-.557c.005-.186.07-.46.313-.849A1 1 0 0 0 25.53.652"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 12a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h27v-8zm1 2v4h4v-4zm24 4H8v-4h18z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31 12h-1v8h1a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})))));
export default SvgSmoking;